import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { TimezoneModule } from '../../timezone/timezone.module';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { InfoFieldModule } from '../../info-field/info-field.module';
import { DatesComponent } from './dates.component';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    IntrackFeatureModule,
    TranslateModule.forChild({}),
    TimezoneModule,
    PipesModule,
    InfoFieldModule,
    SvgIconModule,
  ],
  declarations: [DatesComponent],
  exports: [DatesComponent],
})
export class MonitoringDatesModule {}
